// (A) 중립 ColorPicker API — antd 미접촉. (B) PlainColorPicker(플레인) 에 위임.
// 실측: propsUI(범용 폼) 1파일. onChange 는 hex 문자열로 정규화.
import type { CSSProperties, ReactNode } from 'react'
import { PlainColorPicker } from '../_impl/PlainColorPicker'

/** antd ColorPicker presets 파리티 — 접이식 프리셋 색상 그룹(라벨 + 스와치). colors 는 hex 문자열. */
export interface OmwColorPickerPreset {
  label?: ReactNode
  colors: string[]
  /** 그룹 최초 펼침 여부(기본 true). */
  defaultOpen?: boolean
  key?: string
}

export interface OmwColorPickerProps {
  value?: string
  onChange?: (hex: string) => void
  disabled?: boolean
  /** 실측: true · () => ReactNode(색상 텍스트 커스텀 렌더). */
  showText?: boolean | (() => ReactNode)
  /** 실측: propsUI 에서 inputAttrs.presets 로 전달(TextColorMap 11색). */
  presets?: OmwColorPickerPreset[]
  className?: string
  style?: CSSProperties
}

export function OmwColorPicker(props: OmwColorPickerProps) {
  return <PlainColorPicker {...props} />
}
